export default {
  color: `omegaDark`,
  textDecoration: `none`,
  userSelect: `none`,
  cursor: `pointer`,
  whiteSpace: `pre`,
  transition: `all 250ms ease`,
  p: 0,
  ':visited': {
    color: 'omegaDark'
  },
  ':hover': {
    color: 'omegaDarker'
  }
}
